import { Button, Container, TextField, Typography } from '@mui/material';
import React from 'react'
import icons from "../assets/images/ico.jpg";
import { styled } from '@mui/material/styles';

const TitleContainer = styled(Container)(({ size }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));

const Logo = styled('img')(({ size }) => ({
    width: `${120 * (size || 1)}px`,
}));

function SCCCITitle(props) {
    const { title1, title2, date, size } = props;
    return (
        <TitleContainer>
            <Logo src={icons} alt="logo" size={size} />
            <Typography variant="h5" align="center"  style={{fontSize:`${size}rem`}}>
                {title1}
            </Typography>
            <Typography variant="subtitle1" align="center" gutterBottom style={{fontSize:`${size}rem`}}>
                {title2}
                <br />
                {date}
            </Typography>
        </TitleContainer>
    )
}

export default SCCCITitle;
